export const STEPS = {
  CREATE_OPENDOCK_ACCOUNT: 'create_opendock_account',
  INSTRUCTIONS: 'instructions',
  SCHEDULE: 'schedule',
  SCHEDULE_DATE_AND_TIME: 'schedule_date_and_time',
  SEND_INFO: 'send_info',
  ALREADY_SCHEDULED: 'already_scheduled',
} as const

export type Step = (typeof STEPS)[keyof typeof STEPS]

export const INITIAL_STEP: Step = STEPS.CREATE_OPENDOCK_ACCOUNT
